<template>
    <checkout-step>
        <template slot="title">
            {{ __('Payment mode') }}
        </template>

        <portal-target
            v-if="portalAvailable"
            name="checkout-payment-mode-before"
        />

        <div 
            class="form-group form-control"
            :class="{ 'is-invalid' : errors && Object.keys(errors).length > 0 }"
        >
            <form-error
                field="payment_mode"
                :errors="errors"
            />
        </div>

        <div
            v-for="mode in paymentModes"
            :key="mode.id"
            class="form-group"
        >
            <div class="form-check d-flex align-items-center">
                <input
                    :id="'payment_mode' + mode.id"
                    v-model.number="paymentMode"
                    type="radio"
                    :value="mode.id"
                    class="form-check-input"
                >
                <label
                    class="form-check-label mr-2"
                    :for="'payment_mode' + mode.id"
                >
                    {{ mode.name }} <span v-if="mode.price > 0">({{ mode.price | currency }})</span>
                </label>
                <div
                    class="d-inline-block mr-2 mode-description"
                    v-html="mode.description"
                />
                <img 
                    v-if="mode.icon"
                    :src="mode.icon"
                    class="mode-icon"
                    alt="helper image"
                >
            </div>
        </div>

        <portal-target
            v-if="portalAvailable"
            name="checkout-payment-mode-after"
        />
    </checkout-step>
</template>

<script>
import paymentModeBase from '../../../mixins/checkout/paymentModeBase'

export default {
    mixins: [paymentModeBase]
}
</script>

<style scoped>
.form-check-input {
  margin-top: 0 !important;
}

.mode-description >>> p {
  margin-bottom: 0 !important;
}

.mode-icon {
  max-width: 150px;
  max-height: 50px;
}

.form-control {
  border: none;
  display: none;
  background: none;
}

.form-control.is-invalid {
  display: inline-table;
}

.is-invalid > .invalid-feedback {
  display: block;
}
</style>